<template>
  <el-container class="login_bg" type="flex" style="height:100%">
    <div class="login-box">
      <div class="brand">
        <img :src="require('@/assets/images/sxy.png')" alt="闪销云" width="128">
        <div class="title">快消品经销商首选专业管理软件</div>
      </div>
      <el-main class="login-form-box">
        <el-form :label-position="labelPosition" :model="ruleForm" status-icon :rules="rules" ref="ruleForm"
          class="demo-ruleForm login_form" size="medium">
          <el-form-item label="" prop="passportType" :rules="{
            required: true, message: '账号类型不能为空', trigger: 'blur'
          }">
            <!-- <el-radio-group v-model="ruleForm.passportType" size="large">
              <el-radio-button label="2">用户名</el-radio-button>
              <el-radio-button label="1">手机号</el-radio-button>
              <el-radio-button label="3">邮 箱</el-radio-button>
            </el-radio-group> -->

            <el-tabs v-model="ruleForm.passportType" stretch="true">
              <el-tab-pane label="用户名" name="2"></el-tab-pane>
              <el-tab-pane label="手机号" name="1"></el-tab-pane>
              <el-tab-pane label="邮 箱" name="3"></el-tab-pane>
            </el-tabs>

          </el-form-item>
          <el-form-item label="" prop="cid" :rules="{
            required: true, message: '企业账号不能为空', trigger: 'blur'
          }">
            <el-input type="text" v-model="ruleForm.cid" autocomplete="off" placeholder="企业账号"
              prefix-icon="el-icon el-icon-s-custom"></el-input>
          </el-form-item>
          <el-form-item label="" prop="passport" :rules="{
            required: true, message: '账号不能为空', trigger: 'blur'
          }">
            <el-input type="text" v-model="ruleForm.passport" autocomplete="off" placeholder="账 号"
              prefix-icon="el-icon el-icon-user"></el-input>
          </el-form-item>
          <el-form-item label="" prop="password" :rules="{
            required: true, message: '密码不能为空', trigger: 'blur'
          }">
            <el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="密 码"
              prefix-icon="el-icon el-icon-unlock"></el-input>
          </el-form-item>
          <el-form-item label="" prop="newPassword" v-if="isNewPassword" style="margin-bottom:35px">
            <el-input type="password" v-model="ruleForm.newPassword" autocomplete="off" placeholder="新密码"
              prefix-icon="el-icon el-icon-unlock"></el-input>
          </el-form-item>
          <!-- <el-form-item label="" prop="verifyCode">
          <i class="el-icon el-icon-chat-round"></i>
          <el-input type="text" class="v_code" v-model="ruleForm.verifyCode" placeholder="验证码"></el-input>
          <router-view ref="ruleFormCode"></router-view>
        </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">登 录</el-button>
          </el-form-item>
          <el-form-item style="margin-bottom: 0;">
            <el-col :span="8">
              <router-link :to="{ path: '/reset_password' }" style="text-decoration: none;">
                <el-link type="primary">忘记密码</el-link>
              </router-link>
            </el-col>
            <el-col :span="8" style="text-align:center">
              <router-link :to="{ path: '/reg' }" style="text-decoration: none;">
                <el-link type="primary">注册</el-link>
              </router-link>
            </el-col>
            <el-col :span="8" style="text-align:right">
              <router-link :to="{ path: '/' }" style="text-decoration: none;float:right">
                <el-link type="primary">回到首页</el-link>
              </router-link>
            </el-col>
          </el-form-item>
          <el-form-item v-if="registerInfo.privacyClauseOpen == 1">
            <div style="display: flex;align-items: center;flex-wrap: wrap;">
              <div>
                登录即代表阅读并同意
              </div>
              <el-link @click="dialogVisibleRegisterInfo = true" type="info">《{{ registerInfo.privacyClauseTitle
              }}》</el-link>
            </div>
          </el-form-item>
        </el-form>
      </el-main>
    </div>

    <div class="footer-copyright">Copyright@2016-2023杭州闪派网络科技有限公司版权所有 网站备案/许可证号：
      <a href="https://beian.miit.gov.cn/" target="“_blank&quot;">浙ICP备16031137号</a>
      <img :src="require('@/assets/images/gongan.png')" alt="" style="vertical-align: middle;margin-left: 10px;"> 浙公网安备案
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007569"
        target="“_blank&quot;">33010502007569</a>
    </div>

    <el-dialog :title="registerInfo.privacyClauseTitle" :visible.sync="dialogVisibleRegisterInfo" width="60%">
      <div v-html="registerInfo.privacyClauseContent">
      </div>
      <!-- <div>
        <el-checkbox style="vertical-align: middle;" v-model="checked" @change="(val) => checked==true?dialogVisibleRegisterInfo = false: ''">我已阅读并同意</el-checkbox>
      </div> -->
    </el-dialog>
  </el-container>
</template>
<script>
import {
  login,
  getMenuDate,
  getPaymentInfo
} from '@/api.js'
import {
  mapState
} from 'vuex'
export default {
  name: "Login",
  data() {
    // var checkCode = (rule, value, callback) => {
    // const num = this.identifyCode.identifyCode.replace('=', '').split('+');
    // if (value === '') {
    //   callback(new Error('验证码不能为空'));
    // }
    // else if ((num[0] * 1 + num[1] * 1) != value) {
    //   callback(new Error('验证码输入错误'));
    // } 
    //   else {
    //     callback();
    //   }
    // };
    var validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('新密码不能为空'));
      } else if (!/^(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(value)) {
        callback(new Error('新密码至少包含一位大写字母，一位小写字母，一位数字且长度不能少于8位'));
      } else {
        callback();
      }
    };
    return {
      labelPosition: 'left',
      ruleForm: {
        userType: 1,
        passport: '',
        password: '',
        cid: '',
        newPassword: '',
        loginSource: 1,
        passportType: '1', // 登录账号来源 1=手机号 2= 用户名 3=电子邮件 4= 微信小程序授权.
        verifyCode: '',
        authCode: '',
      },
      rules: {
        // verifyCode: [{
        //   validator: checkCode,
        //   trigger: 'blur'
        // }],
        newPassword: [{
          validator: validateNewPass,
          trigger: 'blur'
        }],
      },
      isNewPassword: false,
      registerInfo: {},
      dialogVisibleRegisterInfo: false,
    };
  },
  created() {
    this.getPaymentInfo()
  },
  mounted() {

  },
  methods: {
    getPaymentInfo() {
      getPaymentInfo().then(res => {
        if (res.code == 0) {
          this.registerInfo = res.data.info
          this.registerMode = res.data.info.registerMode
          if (this.registerMode == 2) {
            this.ref_type = 1
          }
        } else {
          this.$message.error(res.message);
        }
      })
    },
    getMenuDate() {
      getMenuDate().then(res => {
        if (res.ErrorCode == 0) {
          this.$store.commit("refreshMenuList", res.Data.menu_tree);
        } else {
          this.$message.error(res.ErrorMsg);
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.auth_code = this.identifyCode.auth_code
          var reqContent = window.btoa(JSON.stringify(this.ruleForm))
          var sha256 = require("js-sha256").sha256
          var sign = sha256(JSON.stringify(this.ruleForm))
          login({
            reqContent: reqContent,
            sign: sign
          }).then(res => {
            if (res.code == 0) {
              this.$store.commit("refreshAdminID", res.data.adminInfo.AdminID)
              this.$store.commit("refreshNickName", res.data.adminInfo.NickName)
              this.$store.commit("refreshAdminType", res.data.adminInfo.UserType)
              this.$store.commit("refreshAdminId", res.data.adminInfo.Cid)
              this.$store.commit("refreshAdminIsSys", res.data.adminInfo.IsSys)
              this.$store.commit("refreshAdminPermLevel", res.data.adminInfo.PermLevel)
              this.$store.commit("refreshAccessToken", res.data.token)
              this.$router.push({
                path: '/company/basic_info'
                // path: '/company/welcome'
              })
              // this.getMenuDate()
            } else {
              this.$message.error(res.message);
              // this.$refs.ruleFormCode.refreshCode();
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
  computed: {
    ...mapState({
      identifyCode: state => state.identifyCode
    }),
  },
}
</script>
<style scoped lang="scss">
.login_bg {
  width: 100%;
  height: 100%;
  background-image: url('../assets/images/login-bj.jpg');
  background-size: cover;
}

.el-container {
  flex-direction: column;

  .footer-copyright {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    position: absolute;
    bottom: 20px;
    right: 0;
    left: 0;
    margin: 0 auto;
    color: #999999;

    a {
      color: #999999;
    }
  }
}

.el-main {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .el-link.el-link--primary {
    color: #409EFF;
  }
}

.login-box {
  width: 482px;
  height: 660px;
  background: #FFFFFF;
  box-shadow: 0px 0px 18px 0px rgba(179, 179, 179, 0.15);
  border-radius: 12px;
  position: absolute;
  top: 150px;
  right: 230px;
  box-sizing: border-box;
  padding-top: 40px;
}

.brand {
  // position: absolute;
  // left: calc(50% - 112px);
  // top: 40px;
  text-align: center;

  img {
    width: 220px;
  }

  .title {
    color: #999999;
    font-size: 20px;
  }
}

.login-form-box {
  height: auto;
  margin-top: 20px;
}

.login_form {
  width: 380px;

  .title {
    text-align: center;
    font-size: 24px;
    width: 84%;
    margin: 0 auto;
    line-height: 60px;
    margin-bottom: 20px;
    position: relative;
  }

  /deep/ .el-tabs__item {
    font-size: 23px !important;
  }
}

/deep/ .el-input__inner {
  height: 50px;
  font-size: 20px;
}
.el-input--medium{
  font-size: 25px;
  
}
/deep/.el-input__icon{
  line-height: 50px;
}

.login_form .el-form-item__content {
  margin-left: 40px !important;
  position: relative;
}

.login_form .el-icon {
  position: absolute;
  top: 11px;
  left: 5px;
  z-index: 2;
}

.login_form .el-input input {
  padding-left: 25px;
}

.login_form .el-form-item {
  // padding-right: 42px;
  position: relative;
}

.login_form .el-button--primary {
  width: 100%;
  font-size: 20px;
  font-weight: 700;
}

::v-deep .el-radio-button--large .el-radio-button__inner {
  width: 105px;
}

.v_code {
  width: calc(100% - 115px);
}
</style>